import type { SubModelType } from "../../../../../common-deprecated/types/GradeType";

export const SET_SUBMODELS = "model/setSubmodels" as const;

type SetSubmodelsType = { type: typeof SET_SUBMODELS; submodels: SubModelType[] };

export const setSubModels = (submodels: SubModelType[]): SetSubmodelsType => ({ type: SET_SUBMODELS, submodels });

export type SubmodelActionsType = SetSubmodelsType;
